<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-08"></menubar>
    </div>
    <!--  左メニュー 終了 -->

    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{ $t("title.system.inquiryCategory.title") }}</label>
        <sp-smart-button slot="cancel" @click="clickCancel">
          {{ $t("button.common.cancel") }}
        </sp-smart-button>
      </head-title>
    </el-row>


    <div slot="body">
      <div style="display: flex;">
        <div style="width: 50%; height: 20px; padding-top: 6px; font-family: Hiragino Kaku Gothic ProN;font-size: 20px;font-weight: 300;line-height: 20px;text-align: left;color: rgb(82, 82, 80);">
          お問い合わせカテゴリ一覧
        </div>
        <div style="width: 50%;">
          <narrow-down v-if="$checkAuth('010312')" style="float: right;" class="margin-bottom-3" @click="clickAdd">{{$t("title.system.inquiryCategory.searchCreate")}}</narrow-down>
        </div>
      </div>
      <showLoading-dialog :dialog-visible="showLoading" />
      <div class="panel">
        <el-table class="margin-bottom-2" :data="searchResult">
          <el-table-column prop="categoryName" label="カテゴリ">
          </el-table-column>
          <el-table-column prop="subCategoryList" label="子カテゴリ" v-slot="scope">
            {{displayTags(scope.row.subCategoryList)}}
          </el-table-column>
          <el-table-column v-slot="row">
            <div class="buttons">
              <sp-smart-button v-if="$checkAuth('010312')"  class="btn btn-edit" @click="clickEdit(row.row.categoryId)">編集</sp-smart-button>
              <sp-smart-button v-if="$checkAuth('010312')"  class="btn btn-remove" @click="clickRemove(row.row.categoryId)">削除</sp-smart-button>
            </div>
          </el-table-column>
        </el-table>
      </div>

      <inquiry-category-popup
        :buildId="buildingId"
        :categoryId="editCategoryId"
        :visible.sync="inquiryCategoryPopupShow"
        @editCategory="doneInit"
      />

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="deleteIsShow"
        :msgParam="deleteMsgParam"
        @on-isPassParam="isPassDelete">
      </el-dialog-prompt>

    </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import Menubar from "@/components/leftmenu/DashBoard";
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import headTitle from "@/components/common/head/head";
import SpSmartButton from "@/components/common/sp-smart-button";
import InquiryCategoryPopup from "@/components/system/popup/InquiryCategoryPopup";
import elDialogPrompt from "@/components/common/el-dialog-prompt"

export default {
  name: "InquiryCategorySearch",
  components: {
    MainLayout: NewDesignLayout,
    narrowDown: narrowDown,
    Menubar: Menubar,
    headTitle: headTitle,
    SpSmartButton,
    InquiryCategoryPopup,
    elDialogPrompt
  },
  data() {
    return {
      deleteCategoryId: null,
      deleteMsgParam: this.$t("message.common.validation.deleteMessage",{
        field: "お問い合わせカテゴリ"
      }),
      deleteIsShow: false,
      inquiryCategoryPopupShow: false,
      editCategoryId: null,
      isShow: false,
      isSearching: false,
      tableLoadingAnim: null,
      showLoading: false,
      buildingId: null,
      pagination: {
        totalCount: 0,
        totalPage: 0,
        pageSize: 10000,
        pageNumber: 1
      },

      // 检索結果
      searchResult: [
        {
          ownerId: null,
          ownerName: null,
          ownerExId: null,
          buildingId: null,
          buildingName: null,
          buildingExId: null,
          categoryId: null,
          categoryName: null,
          subCategoryList:[
            {
              subCategoryId: null,
              subCategoryName: null,
            }
          ]
        },
      ],
    };
  },
  mounted() {
    this.doneInit();
  },
  created() {
    this.$authCheck("010311");
    let breadcrumb = [
    {
          path: "/",
          title: "label.router.home",
        },
        {
          path: "/system/setting/various",
          title: "label.router.set",
        },
        {
          path: "",
          title: "label.router.comprehensive",
        },
        {
          path: "/system/buildings/search",
          title: "label.router.building",
        },
        {
          path: "",
          title: "label.router.detailBuilding",
        },
        {
          path: "",
          title: "お問い合わせカテゴリ管理",
        },
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  },
  methods: {
    isPassDelete(param){
      if(param) {
        this.deleteCategory()
      }
    },
    clickAdd() {
      this.inquiryCategoryPopupShow = true;
    },

    clickCancel() {
      this.$router.push({
        name: 'system-building-manage-menu',
        params: {
          buildingId: this.buildingId
        }
      });
    },

    clickEdit(categoryId) {
      this.editCategoryId = categoryId
      this.inquiryCategoryPopupShow = true;
    },

    deleteCategory(){
      this.showLoading = true;
      SystemManageApi.deleteInquiryCategory(this.deleteCategoryId)
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.deleteSuccess();
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.showLoading = false;
          this.doneInit()
        })
    },

    clickRemove(categoryId) {
      this.deleteCategoryId = categoryId
      this.deleteIsShow = true
    },

    //削除
    deleteSuccess: function () {
      this.$messageIotSuccess(this.$t("message.common.delete", {
        field: "お問い合わせカテゴリ",
      }));
    },

    doneInit() {
      this.editCategoryId = null
      this.buildingId = this.$route.query.buildingId;
      this.searchResult = [];
      this.showLoading = true;
      SystemManageApi.inquiryCategorySearch({
        buildingId: this.buildingId,
        pageSize: this.pagination.pageSize,
        pageNumber: this.pagination.pageNumber
      })
      .catch((error) => {
        errorCodeMsg(error, this)
        this.showLoading = false;
      })
      .then(({data}) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        this.showLoading = false;

        this.pagination.totalCount = data.body.totalCount;
        this.pagination.totalPage = data.body.totalPage;
        this.pagination.pageSize = data.body.pageSize;
        this.pagination.pageNumber = data.body.pageNumber;
        this.searchResult = data.body.body
      })
      .finally(() => {
        this.showLoading = false;
      });
    },

    displayTags(tags) {
      if (tags != undefined && tags != null && tags.length > 0) {
        return tags.map(tag => tag.subCategoryName).join('、');
      } else {
        return ''
      }
    },

    onPaging({ pageSize, pageNumber }) {
      this.pagination.pageSize = pageSize;
      this.pagination.pageNumber = pageNumber;
      this.doneInit();
    }
  }
};
</script>

<style lang="scss" scoped>

::v-deep .buttons{
  .my-button{
    color: #525250;
    font-size: 13px;
    background-color: #f7f7f2 !important;
    left: 55px;
    position: relative;
    height: 40px;
    width: 40%;
    text-align: center;
  }
}

::v-deep .cancel-width{
  .my-button{
    height: 32px;
  }
}
.float-left {
  float: left;
}
::v-deep .new-input-style {
  .el-input__inner {
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}
::v-deep .zdyInput {
  width: 188px;
  font-size: 15px;
  height: 40px;
  border-radius: 8px;
  box-shadow: -2px -2px 4px #fff,
    4px 4px 4px #e6e6e1;
  .el-input__inner {
    height: 40px;
    border-radius: 10px;
    background-color: #f2f2ed;
    border: 0;
    color: #525250;
  }
  .el-input__suffix {
    top: 0px;
  }
  .el-input__icon {
    line-height: 25px !important;
  }
}
.ColorChange {
  font-size: 14px;
  margin-left: 20px;
  margin-right: 13px;
  color: #6b6b69 !important;
}
::v-deep .zdyselect {
  width: 120px !important;
  font-size: 15px;
  height: 40px !important;
  border-radius: 10px !important;
  box-shadow: -2px -2px 4px #fff,
    4px 4px 4px #e6e6e1;
  .el-input__inner {
    height: 40px !important;
    border-radius: 10px !important;
    background-color: #f2f2ed !important;
    border: 0;
    color: #525250 !important;
  }
  .el-input__suffix {
    top: 0px;
    .el-input__icon {
      line-height: 25px !important;
      color: #c0c4cc;
    }
  }
}
::v-deep .st-page-size label{
    top: 0px;
  }

.limit-length {
   width: 100px !important;
}
</style>
